import React, { Component } from 'react';

var checkbox = {
    position: 'relative',
    bottom: '1px',
    height: '16px',
    width: '16px',
    borderRadius: '3px',
    border: '1px solid #888'
}

var enabled = {
    border: '10px solid #397',
    borderWidth: '0 0 4px 4px',
    transform: 'rotate(-50deg)',
    position: 'absolute',
    height: '4px',
    width: '10px',
    left: '1px',
    top: '3px'
}
var disabled = {

}
export default class DateFilter extends Component {
    constructor(props) {
        super(props);
        this.state = {
            startingYear: 2018,
            data: {
                Hours: {
                    'ALL': false,
                    '12:00am': false,
                    '1:00am': false,
                    '2:00am': false,
                    '3:00am': false,
                    '4:00am': false,
                    '5:00am': false,
                    '6:00am': false,
                    '7:00am': false,
                    '8:00am': false,
                    '9:00am': false,
                    '10:00am': false,
                    '11:00am': false,
                    '12:00pm': false,
                    '1:00pm': false,
                    '2:00pm': false,
                    '3:00pm': false,
                    '4:00pm': false,
                    '5:00pm': false,
                    '6:00pm': false,
                    '7:00pm': false,
                    '8:00pm': false,
                    '9:00pm': false,
                    '10:00pm': false,
                    '11:00pm': false
                },
                Days: {
                    'ALL': false,
                    'Sunday': false,
                    'Monday': false,
                    'Tuesday': false,
                    'Wednesday': false,
                    'Thursday': false,
                    'Friday': false,
                    'Saturday': false
                },
                Months: {
                    'ALL': false,
                    'January': false,
                    'February': false,
                    'March': false,
                    'April': false,
                    'May': false,
                    'June': false,
                    'July': false,
                    'August': false,
                    'September': false,
                    'October': false,
                    'November': false,
                    'December': false
                },
                Years: {}

            }
        }
    }

    toggle = (type, param) => (e) => {
        var newState = Object.assign({}, this.state.data)
        newState[type] = Object.assign({}, this.state.data[type])

        if (param === 'ALL') {
            var newVal = newState[type][param] ? false : true
            for (var par in newState[type]) {
                newState[type][par] = newVal
            }
        } else {
            if (newState[type][param]) {
                newState[type].ALL = false
            }
            newState[type][param] = newState[type][param] ? false : true
        }
        this.setState({ data: newState })
    }

    confirm = () => {
        var send = {}
        for (var type in this.state.data) {
            for (var param in this.state.data[type]) {
                if (this.state.data[type][param]) {
                    if (!send.hasOwnProperty(type)) {
                        send[type] = {}
                    }
                    send[type][param] = true
                }
            }
        }
        this.props.confirmDateFilters(send)
    }
    cancel = () => {
        this.props.cancel()
    }
    componentDidMount = () => {
        var newData = Object.assign({}, this.state.data)
        newData.Years = { ALL: false }
        var year = new Date().getYear() + 1900
        while (year >= new Date(this.state.startingYear, 0).getYear() + 1900) {
            newData.Years[year--] = false
        }
        for (var type in this.props.data) {
            for (var param in this.props.data[type]) {
                if (this.props.data[type][param]) {
                    newData[type][param] = true
                }
            }
        }
        this.setState({ data: newData })
    }


    render() {
        var box = []
        for (var type in this.state.data) {
            var params = []
            for (var param in this.state.data[type]) {
                var toAdd = (
                    <div key={param} style={{ padding: '5px', display: 'flex', flexFlow: 'row nowrap' }} onClick={this.toggle(type, param)}>
                        <div style={checkbox}>
                            {this.state.data[type][param] ? <div style={enabled}> </div> : <div style={disabled}> </div>}
                        </div>
                        <div style={{ paddingLeft: '5px' }}>{param}</div>
                    </div>
                )
                console.log(parseInt(param))
                if (param == 'ALL' || !isNaN(param)) {
                    params.unshift(toAdd)
                } else {
                    params.push(toAdd)
                }
            }

            box.push(
                <div key={type} style={{ flex: type === "Years" ? '2 1 20px' : '3 1 20px' }}>

                    <div style={{ textAlign: 'center', color: '#2A6AA9', fontSize: '18px', padding: '5px' }}>
                        {type}
                    </div>
                    <div style={{ maxHeight: '370px', overflow: 'auto' }}>
                        {params}
                    </div>
                </div>
            )
        }


        return (
            <div className="blackout">
                <div style={{ zIndex: 500, backgroundColor: '#fff', height: '510px', width: '550px', position: 'fixed', top: '50%', left: '50%', transform: ' translate(-50%, -50%)', borderRadius: '10px', boxShadow: '0px 0px 5px #888' }}>
                    <div className="viewCloser" style={{ zIndex: 500, display: 'block' }} onClick={this.cancel}></div>
                    <div style={{ padding: '15px', height: '405px', width: '520px', position: 'relative', display: 'flex', flexFlow: 'column wrap', justifyContent: 'space-between' }}>
                        {box}
                    </div>
                    <div className="button" onClick={this.confirm}>Confirm Date Filters</div>
                </div>
            </div>
        )
    }
}
